import type { GlobalSearchResponse } from '../types/search';
import { authFetch } from '../lib/authFetch';
import { buildQueryString } from '../lib/query';
import { json, resolveBase } from './client';
import type { ApiErrorPayload } from './contracts';

const _DEFAULT_LIMIT = 5;

type GlobalSearchApiResponse = ApiErrorPayload & {
  data?: GlobalSearchResponse;
  query?: string;
  groups?: GlobalSearchResponse['groups'];
  took_ms?: number;
};

export type GlobalSearchParams = {
  limit?: number;
  signal?: AbortSignal;
};

export async function runGlobalSearch(
  apiBase: string,
  query: string,
  params: GlobalSearchParams = {}
): Promise<GlobalSearchResponse> {
  const trimmed = query.trim();
  if (!trimmed) {
    return { query: '', groups: [] };
  }

  const base = resolveBase(apiBase);
  const limit = params.limit ?? _DEFAULT_LIMIT;
  const queryString = buildQueryString({ q: trimmed, limit }, { includeQuestionMark: true });

  const response = await authFetch(`${base}/api/search${queryString}`, { signal: params.signal });
  const data = await json<GlobalSearchApiResponse>(response);

  if (data?.status === 'success') {
    return data.data ?? { query: trimmed, groups: [] };
  }

  return data as GlobalSearchResponse;
}
